import React from 'react';
import PropTypes from 'prop-types';

import styles from './index.styl';

export default function GridSection(props) {
  return (
    <div className={styles.section}>
      {React.Children.map(props.children, (item, i) => {
        if (typeof item !== 'object' || item === null) return item;

        const {
          type: Item,
          props: childProps,
        } = item;

        return (
          <Item
            key={i}
            order={i + 1}
            {...childProps}
          />
        );
      })}
    </div>
  );
}

GridSection.propTypes = {
  children: PropTypes.node,
};

export { GridSection as StorybookComponent };
